import { useContext, useEffect } from 'react'

import { PaddingInset } from '@cash-design-system/react'
import { FormBlockerElementCellDefaultElement } from '@cash-web/protos/squareup/franklin/form_blocker.pb'
import { ArcadeCellFromProto } from '@cash-web/shared/ui-arcade-cell'
import { useLogCashWebCdfEvent } from '@cash-web/shared-feature-analytics'
import { getBlockerAction } from '@cash-web/shared-flow-feature-main'
import { WebViewUnsupportedFeature } from '@squareup/customer-data-events-web'

import { FormBlockerContext } from '../../FormBlockerContext'

export const CellDefaultElement = ({
  cell,
  cell_action: cellAction,
  selection_group_id: selectionGroupId,
}: FormBlockerElementCellDefaultElement) => {
  const logCdfEvent = useLogCashWebCdfEvent()
  const context = useContext(FormBlockerContext)

  useEffect(() => {
    if (cellAction) {
      const blockerAction = getBlockerAction(cellAction)
      if (!blockerAction.isSupported) {
        logCdfEvent(
          WebViewUnsupportedFeature({
            source: 'CellDefaultElement',
            feature: 'BLOCKER_ACTION',
            action: blockerAction.actionName,
          })
        )
      }
    }
  }, [cellAction, logCdfEvent])

  if (!cell) {
    return null
  }

  return (
    <PaddingInset>
      <ArcadeCellFromProto
        protoProps={cell}
        onClick={() => {
          if (cellAction) {
            context.onFormBlockerAction(cellAction)
          }
        }}
        selectionGroupId={selectionGroupId}
      />
    </PaddingInset>
  )
}
